import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { PhoneFilterOptions } from '@app/akita/api/products/models/phone-filter-options.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { logSortBy } from '@app/core/services/google-analytics.lazy';
import { GoogleAnalyticsService } from '@app/core/services/google-analytics.service';
import { SearchSortBy } from '@app/shared/models/api/listing/search/search-sort-by.enum';
import { Subject } from 'rxjs';
import { FilterByPhoneFiltersComponent } from '../../../components/filters/filter-by-phone-filters/filter-by-phone-filters.component';
import { SortByFilterComponent } from '../../../components/filters/sort-by-filter/sort-by-filter.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-featured-filters-toolbar',
  templateUrl: './featured-filters-toolbar.template.html',
  styleUrls: ['./featured-filters-toolbar.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, SortByFilterComponent, FilterByPhoneFiltersComponent],
})
export class FeaturedFiltersToolbarComponent implements OnDestroy {
  @Input() public phoneFilterOptions?: PhoneFilterOptions | null;
  @Input() public loading?: boolean | null;

  @Output() public readonly filterPhoneSortByChanged: EventEmitter<SearchSortBy>;
  @Output() public readonly phoneFilterOptionsByChanged: EventEmitter<PhoneFilterOptions>;

  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly analytics: GoogleAnalyticsService,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.destroySubject = new Subject();

    this.filterPhoneSortByChanged = new EventEmitter();
    this.phoneFilterOptionsByChanged = new EventEmitter();
  }

  public onSortByChanged($event?: SearchSortBy | null): void {
    if ($event) {
      this.filterPhoneSortByChanged.emit($event);
      logSortBy(
        this.analytics.logEventWrapper,
        $event,
        this.akitaRouterQuery.country || '?'
      );
    } else {
      logSortBy(
        this.analytics.logEventWrapper,
        'TOP_PICKS',
        this.akitaRouterQuery.country || '?'
      );
    }
  }

  public onPhoneFiltersChanged($event?: PhoneFilterOptions | null): void {
    if ($event) {
      this.phoneFilterOptionsByChanged.emit($event);
    }
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
